export const version = "wordlists/5.0.6";
//# sourceMappingURL=_version.js.map